/** localStorage key used to notify other tabs that the user's organization changed. */
export const ORGANIZATION_CHANGE_RELOAD_KEY = 'organization-change-reload';

/**
 * Clears the revoked BioVerse session, signals sibling tabs, and navigates this tab home.
 * The navigation callback is injectable so the behavior can be tested without leaving the page.
 */
export function signalOrganizationChangeAndReload(
  navigate: (path: string) => void = (path) => window.location.assign(path),
) {
  localStorage.removeItem('sessionId');
  localStorage.removeItem(ORGANIZATION_CHANGE_RELOAD_KEY);
  localStorage.setItem(ORGANIZATION_CHANGE_RELOAD_KEY, String(Date.now()));
  navigate('/');
}

/**
 * Registers a listener that sends sibling tabs home when the organization-change signal is written.
 * Returns a cleanup function for removing the storage listener.
 */
export function registerOrganizationChangeReloadListener(
  navigate: (path: string) => void = (path) => window.location.assign(path),
) {
  const handleStorage = (event: StorageEvent) => {
    if (event.key !== ORGANIZATION_CHANGE_RELOAD_KEY || !event.newValue) return;
    localStorage.removeItem(ORGANIZATION_CHANGE_RELOAD_KEY);
    navigate('/');
  };

  window.addEventListener('storage', handleStorage);
  return () => window.removeEventListener('storage', handleStorage);
}
